module.exports = __webpack_public_path__ + "static/img/channel3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/channel3.png
// module id = 545
// module chunks = 0